import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi! I'm a <span className="purple">Software Developer </span> at Streamboost, currently based in <span className="purple">Germany</span>.
            <br />
            <br />

            I expanded my technical expertise by completing a university-level program in <span className="purple">Computer Technologies and Programming</span>, followed by an intensive <span className="purple">Full-Stack Java Developer</span> Bootcamp.
            <br />
            <br />
            I hold a <span className="purple">Master's degree in Business Administration</span>.
            <br />
            <br />

            Beyond work, I love <span className="purple">traveling, cycling, photography, and writing tech blogs </span>— activities that fuel both my creativity and problem-solving mindset.
          </p>

          <p style={{ color: "rgb(155 126 172)" }}>
            "I believe technology should solve real problems and make everyday life better"{" "}
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
